import { isToday, isYesterday } from 'date-fns';

import { ChatCategory } from '../model/chat-category.model';
import { ChatSummary } from '../model/chat-summary.model';

export function chatSummaryTransformer(
    categories?: ChatCategory[],
): ChatSummary[] {
    return categories?.map<ChatSummary>((e) => {
        const lastUpdatedOn = determineStrDate2(
            e.lastUpdatedOn as unknown as string,
        );
        return {
            ...e,
            lastUpdatedOn,
            avatar: '', // TODO
            name: e.correspondent?.msftDisplayName,

            // TODO use focus once BE can send it
            // label: e.subCategories[0].focus,
            label: e.subCategories?.[0].chat.topic,
            hasMultipleConversations: e.subCategories?.length !== 1,
            isToday: isToday(lastUpdatedOn),
            isYesterday: isYesterday(lastUpdatedOn),
            isOpen: false,
        };
    });
}

function determineStrDate2(value?: string): Date {
    if (value != null) {
        return new Date(
            value.trim().toLowerCase().endsWith('z') ? value : `${value}Z`,
        );
    }
    return null;
}
